import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "./Notification.css";

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [notificationData, setNotificationData] = useState({
    title: "",
    body: "",
    image: null
  });

  const getNotifications = async () => {
    try {
      const response = await fetch(
        "https://api.experts4u.in/api/v1/Notification/GetNotification"
      );
      const data = await response.json();
      if (data.success) {
        setNotifications(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNotificationData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNotificationData(prev => ({
      ...prev,
      image: file
    }));
  };

  const sendNotificationToAll = async () => {
    try {
      const formData = new FormData();
      formData.append('titel', notificationData.title);
      formData.append('body', notificationData.body);
      if (notificationData.image) {
        formData.append('Image', notificationData.image);
      }

      const response = await fetch(
        "https://api.experts4u.in/api/v1/Notification/sendallusersnotification",
        {
          method: 'POST',
          body: formData
        }
      );

      const result = await response.json();
      
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Notification sent to all users successfully!'
        });
        setShowModal(false);
        setNotificationData({ title: "", body: "", image: null });
        getNotifications(); // Refresh the list
      } else {
        throw new Error(result.message || 'Failed to send notification');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error.message || 'Failed to send notification'
      });
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);

  // Get current notifications
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = notifications.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="app-main notification-page">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="page-title-wrap">
                      <h1 className="page-title mb-0">
                        <i className="fas fa-bell mr-2 text-primary"></i>
                        Notifications
                      </h1>
                      <p className="text-muted mt-2 mb-0">
                        Manage and view all your notifications
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-primary d-flex align-items-center mr-2"
                        onClick={() => setShowModal(true)}
                      >
                        <i className="fas fa-paper-plane mr-2"></i>
                        Send to All Users
                      </button>
                      <div className="notification-stats">
                        <div className="stat-card">
                          <div className="stat-number">{notifications.length}</div>
                          <div className="stat-label">Total Notifications</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>

                <div className="page-section">
                  <div className="card notification-card">
                    <div className="card-body table-responsive">
                      {loading ? (
                        <div className="loader-container">
                          <div className="loader"></div>
                          <p>Loading notifications...</p>
                        </div>
                      ) : (
                        <>
                          <table className="table table-hover table-sm custom-table">
                            <thead>
                              <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col">User</th>
                                <th scope="col">Title</th>
                                <th scope="col">Message</th>
                                <th scope="col">Image</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentItems.map((item, index) => (
                                <tr key={item._id} className="notification-row">
                                  <td className="text-center">
                                    {indexOfFirstItem + index + 1}
                                  </td>
                                  <td>
                                    <div className="user-badge">
                                      <span className="user-initial">
                                        {item.userdata.user_name.charAt(0)}
                                      </span>
                                      <span className="user-name">
                                        {item.userdata.user_name}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="notification-title">
                                      {item.notification.title}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="notification-body">
                                      {item.notification.body}
                                    </div>
                                  </td>
                                  <td>
                                    {item.notification.image ? (
                                      <div className="notification-image">
                                        <img
                                          src={item.notification.image}
                                          alt="Notification"
                                          onClick={() =>
                                            window.open(
                                              item.notification.image,
                                              "_blank"
                                            )
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <span className="no-image">No Image</span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="pagination-container">
                            <nav>
                              <ul className="pagination justify-content-center">
                                <li
                                  className={`page-item ${
                                    currentPage === 1 ? "disabled" : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                  >
                                    Previous
                                  </button>
                                </li>
                                {(() => {
                                  const totalPages = Math.ceil(notifications.length / itemsPerPage);
                                  const maxButtons = 6;
                                  let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
                                  let endPage = Math.min(totalPages, startPage + maxButtons - 1);

                                  if (endPage - startPage + 1 < maxButtons) {
                                    startPage = Math.max(1, endPage - maxButtons + 1);
                                  }

                                  return Array.from(
                                    { length: endPage - startPage + 1 },
                                    (_, i) => startPage + i
                                  ).map(pageNum => (
                                    <li
                                      key={pageNum}
                                      className={`page-item ${
                                        currentPage === pageNum ? "active" : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() => paginate(pageNum)}
                                      >
                                        {pageNum}
                                      </button>
                                    </li>
                                  ));
                                })()}
                                <li
                                  className={`page-item ${
                                    currentPage ===
                                    Math.ceil(notifications.length / itemsPerPage)
                                      ? "disabled"
                                      : ""
                                  }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={
                                      currentPage ===
                                      Math.ceil(
                                        notifications.length / itemsPerPage
                                      )
                                    }
                                  >
                                    Next
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Send to All Modal */}
      {showModal && (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send Notification to All Users</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={notificationData.title}
                      onChange={handleInputChange}
                      placeholder="Enter notification title"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label>Message</label>
                    <textarea
                      className="form-control"
                      name="body"
                      value={notificationData.body}
                      onChange={handleInputChange}
                      rows="4"
                      placeholder="Enter notification message"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>Image (Optional)</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImageChange}
                      accept="image/*"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendNotificationToAll}
                >
                  Send Notification
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && <div className="modal-backdrop show"></div>}
    </>
  );
}

export default Notification;